const criteoEventType = {
    homepage: 'homePage',
    product: 'product',
    category: 'category',
    subCategory: 'subCategory',
    cart: 'cart',
    orderConfirmation: 'orderConfirmation',
};

export default criteoEventType;
